import _Reflect$construct from '@babel/runtime-corejs3/core-js/reflect/construct';
import _classCallCheck from '@babel/runtime-corejs3/helpers/classCallCheck';
import _createClass from '@babel/runtime-corejs3/helpers/createClass';
import _assertThisInitialized from '@babel/runtime-corejs3/helpers/assertThisInitialized';
import _inherits from '@babel/runtime-corejs3/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime-corejs3/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime-corejs3/helpers/getPrototypeOf';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import * as React from 'react';
import './third_party/gl-matrix.js';
import { initShaderProgram, initBuffers, initTexture, cleanGL, updateTexture, drawScene } from './utils.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var WebGLEffectPlayer = /*#__PURE__*/function (_React$Component) {
  _inherits(WebGLEffectPlayer, _React$Component);

  var _super = _createSuper(WebGLEffectPlayer);

  function WebGLEffectPlayer(props) {
    var _this;

    _classCallCheck(this, WebGLEffectPlayer);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onImageLoad", function () {
      var _this$props$onImageLo, _this$props;

      (_this$props$onImageLo = (_this$props = _this.props).onImageLoad) === null || _this$props$onImageLo === void 0 ? void 0 : _this$props$onImageLo.call(_this$props);
    });

    _defineProperty(_assertThisInitialized(_this), "onImageError", function () {
      var _this$props$onImageEr, _this$props2;

      (_this$props$onImageEr = (_this$props2 = _this.props).onImageError) === null || _this$props$onImageEr === void 0 ? void 0 : _this$props$onImageEr.call(_this$props2);
    });

    _defineProperty(_assertThisInitialized(_this), "cleanVideoEventListeners", function () {
      if (!_this.videoEl) return;

      _this.videoEl.removeEventListener('loadedmetadata', _this.handleLoadedMetadata);

      _this.videoEl.removeEventListener('playing', _this.handlePlaying);

      _this.videoEl.removeEventListener('timeupdate', _this.handleTimeUpdate);
    });

    _defineProperty(_assertThisInitialized(_this), "handleLoadedMetadata", function () {
      // 避免组件卸载后因为 canvasRef.current 为空报错
      if (_this.isUnmount || !_this.canvasRef.current || !_this.videoEl) {
        return;
      }

      var isMobileView = _this.props.isMobileView;
      _this.canvasRef.current.width = isMobileView ? _this.videoEl.videoWidth / 2 : _this.videoEl.videoWidth;
      _this.canvasRef.current.height = isMobileView ? _this.videoEl.videoHeight : _this.videoEl.videoHeight / 2;

      _this.onVideoReady(_this.videoEl);
    });

    _defineProperty(_assertThisInitialized(_this), "handlePlaying", function () {
      _this.hasPlayed = true;
    });

    _defineProperty(_assertThisInitialized(_this), "handleTimeUpdate", function () {
      _this.hasUpdated = true;
    });

    _defineProperty(_assertThisInitialized(_this), "onVideoReady", function (video) {
      if (!_this.canvasRef.current) return;
      var _this$props3 = _this.props,
          isMobileView = _this$props3.isMobileView,
          onVideoPlay = _this$props3.onVideoPlay;

      var gl = _this.canvasRef.current.getContext('webgl');

      _this.gl = gl;

      if (!gl) {
        /* eslint-disable-next-line no-console */
        console.log('Unable to initialize WebGL. Your browser or machine may not support it.');

        _this.fallbackToPng();
      } else {
        // Initialize a shader program; this is where all the lighting
        // for the vertices and so forth is established.
        var _initShaderProgram = initShaderProgram(gl, !!isMobileView),
            shaderProgram = _initShaderProgram.shaderProgram,
            vertexShader = _initShaderProgram.vertexShader,
            fragmentShader = _initShaderProgram.fragmentShader;

        _this.program = shaderProgram;
        _this.vertexShader = vertexShader;
        _this.fragmentShader = fragmentShader; // Collect all the info needed to use the shader program.
        // Look up which attributes our shader program is using
        // for aVertexPosition, aVertexNormal, aTextureCoord,
        // and look up uniform locations.

        var programInfo = {
          program: shaderProgram,
          attribLocations: {
            position: gl.getAttribLocation(shaderProgram, 'aPosition'),
            textureCoord: gl.getAttribLocation(shaderProgram, 'aTextureCoord')
          },
          uniformLocations: {
            sTexture: gl.getUniformLocation(shaderProgram, 'sTexture')
          }
        }; // Here's where we call the routine that builds all the
        // objects we'll be drawing.

        var buffers = initBuffers(gl);
        var texture = initTexture(gl); // Draw the scene repeatedly

        var render = function render() {
          if (!_this.canvasRef.current) {
            return;
          }

          if (_this.isCanPlay) {
            updateTexture(gl, texture, video);
          }

          drawScene(gl, programInfo, buffers, texture);
          requestAnimationFrame(render);
        };

        onVideoPlay === null || onVideoPlay === void 0 ? void 0 : onVideoPlay();
        requestAnimationFrame(render);
      }
    });

    _this.canvasRef = /*#__PURE__*/React.createRef();
    _this.isUnmount = false;
    _this.hasPlayed = false;
    _this.hasUpdated = false;
    _this.state = {
      isImageShow: false
    };
    return _this;
  }

  _createClass(WebGLEffectPlayer, [{
    key: "isCanPlay",
    get: function get() {
      return this.hasPlayed && this.hasUpdated;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setupVideo();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.isUnmount = true;

      if (this.gl) {
        cleanGL(this.gl, this.program, this.vertexShader, this.fragmentShader);
      }

      this.cleanVideoEventListeners();
    }
  }, {
    key: "fallbackToPng",
    value: function fallbackToPng() {
      var _this$props4 = this.props,
          imageUrl = _this$props4.imageUrl,
          onVideoError = _this$props4.onVideoError;
      onVideoError === null || onVideoError === void 0 ? void 0 : onVideoError();

      if (imageUrl) {
        this.setState({
          isImageShow: true
        });
      }
    }
  }, {
    key: "setupVideo",
    value: function setupVideo() {
      var _this2 = this;

      var _this$props5 = this.props,
          videoUrl = _this$props5.videoUrl,
          loop = _this$props5.loop,
          onVideoEnded = _this$props5.onVideoEnded;
      var video = document.createElement('video');
      this.videoEl = video;
      video.crossOrigin = 'anonymous';
      video.autoplay = true;
      video.muted = true;
      video.loop = !!loop;
      video.setAttribute('playsinline', 'playsinline');
      video.setAttribute('webkit-playsinline', 'webkit-playsinline');
      video.setAttribute('x5-video-player-type', 'h5-page');

      if (onVideoEnded) {
        video.onended = onVideoEnded;
      }

      video.addEventListener('loadedmetadata', this.handleLoadedMetadata, true);
      video.addEventListener('playing', this.handlePlaying, true);
      video.addEventListener('timeupdate', this.handleTimeUpdate, true);
      video.src = videoUrl;

      try {
        video.play().catch(function () {
          _this2.fallbackToPng();
        });
      } catch (_unused) {
        this.fallbackToPng();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          onClick = _this$props6.onClick,
          imageUrl = _this$props6.imageUrl;
      return this.state.isImageShow ? /*#__PURE__*/React.createElement("img", {
        className: "image-effect",
        src: imageUrl,
        onLoad: this.onImageLoad,
        onError: this.onImageError,
        onClick: onClick
      }) : /*#__PURE__*/React.createElement("canvas", {
        id: "webgl-effect-glcanvas",
        ref: this.canvasRef,
        onClick: onClick
      });
    }
  }]);

  return WebGLEffectPlayer;
}(React.Component);

export { WebGLEffectPlayer };
